var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"About"},[_c('div',{staticClass:"container"},[_c('Block7',{attrs:{"title":_vm.blocks.title,"figure":_vm.blocks.image,"content":_vm.blocks.content,"bg_color":_vm.blocks.bg_color}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b9c0dae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/About.vue
// module id = 83
// module chunks = 0